import { Pipe, PipeTransform } from '@angular/core';
import { SaleBoard } from '@modules/projects/project-detail/price-list/sale-board/sale-board';

@Pipe({
  name: 'filter_matrix',
  pure: false,
})
export class FilterMatrixPipe implements PipeTransform {
  transform(items: SaleBoard[], filter: any): any[] {
    if (!items) return [];
    if (!filter) return items;

    if (filter.byLevel !== null && filter.byLevel !== undefined) {
      items = items.filter(f => f.id === filter.byLevel);
    }

    if (filter.priceTo || filter.priceFrom || filter.byLotInfo) {
      items = items.filter(f => f.type !== 'service');
      items.forEach(f => {
        if (f.type === 'detail') {
          f.slots.forEach((c, i) => {
            if (i === 0) {
              return;
            }

            if (filter.byLotInfo) {
              if (c?.floor_id && c?.floor_id?.value === filter.byLotInfo) {
                c.isHide = false;
              } else {
                c.isHide = true;
              }
            } else if (filter.priceFrom && filter.priceTo) {
              if (c?.price && c?.price?.value <= filter.priceTo && c?.price?.value >= filter.priceFrom) {
                c.isHide = false;
              } else {
                c.isHide = true;
              }
            } else if (filter.priceTo && !filter.priceFrom) {
              if (c?.price && c?.price?.value <= filter.priceTo) {
                c.isHide = false;
              } else {
                c.isHide = true;
              }
            } else if (!filter.priceTo && filter.priceFrom) {
              if (c?.price && c?.price?.value >= filter.priceFrom) {
                c.isHide = false;
              } else {
                c.isHide = true;
              }
            } else if (!filter.priceTo && !filter.priceFrom) {
              c.isHide = false;
            }
          });
        } else {
          // clr = f.color;
        }
      });
    } else {
      items.forEach(f => {
        if (f.type === 'detail') {
          f.slots.forEach((c, i) => {
            if (i === 0) {
              return;
            }
            if (!filter.priceTo && !filter.priceFrom) {
              c.isHide = false;
            }
          });
        }
      });
    }
    return items;
  }
}
